import * as PIXI from "pixi.js";
import { CIRCLE_RADIUS } from "./Constants";


export default class ColorCircle extends PIXI.Graphics {
  constructor(public color: number) {
    super();
    this.draw();
  }
  draw(isStroked: boolean = false) {
    this
      .clear()
      .circle(0, 0, CIRCLE_RADIUS)
      .fill(this.color);
    if (isStroked) {
      this
        .circle(0, 0, CIRCLE_RADIUS + 4)
        .fill({ color: 0x000000, alpha: 0 })
        .stroke({ width: 1.5, color: 0x000000 })
    }
  }
}